module.exports = __webpack_public_path__ + "img/mobile_DFM.a049ce8f.gif";